//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function() {
  const content = angular.module('curalate');

    /**
     * Custom-styled loadable component for search filters. Displays the loading graphic until the dependency is true.
     *
     * @param {expression} dependency - the condition that must be satisfied to display filter contents
     * @param {string} size - size of the loading graphic. Current options are small and large.
     */
  content.component('searchFilterLoadable', {
    bindings: {
      dependency: '<',
      size: '@',
    },
    template: require('@partials/search-filter-loadable.html'),
    transclude: true,
  });
})();
